import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const areMapSettingsReadySelector = (state: AppState) => state.map.mapSettings.isReady;
export const useAreMapSettingsReadySelector = () => useSelector(areMapSettingsReadySelector);
